var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`
    statistics-beam
    font-weight-light
    ${_vm.color}
    ${_vm.color && _vm.color.includes('lighten') || _vm.color && _vm.color.includes('darken')? '':'lighten-1'}
    ${_vm.text_color}--text
    `,style:(`
    height: calc(${_vm.max_value !== 0? `${(_vm.value / _vm.max_value)} * (100% - (${_vm.takt_sum_height?_vm.takt_sum_height:'25px'} * ${_vm.no_zoom?1:'var(--taktplan_zoom)'})) ${_vm.margin_top?`- 1px`:''}`:'0px'});
    ${_vm.color === '' && _vm.value !== 0? 'border: solid 1px var(--v-primary-base);':'color: black;'}
    ${_vm.width?`width: ${_vm.width};`:''}
    ${_vm.no_zoom?`font-size: 16px;`:''}
    ${_vm.margin_top?`margin-top: ${_vm.margin_top}`:''}
  `)},[(_vm.showIcon(_vm.icon))?_c('TTooltip',{staticClass:"tooltip-content",attrs:{"value":_vm.tooltip ? _vm.tooltip : ''}},[_c('TIcon',{staticClass:"statistics-beam-icon",attrs:{"name":_vm.icon,"color":"black","small":""}}),(!_vm.no_text)?_c('div',[_vm._v(_vm._s(_vm.value))]):_vm._e(),_vm._t("default")],2):_c('TTooltip',{staticClass:"tooltip-content",attrs:{"value":_vm.tooltip ? _vm.tooltip : ''}},[(!_vm.no_text)?_c('div',[_vm._v(_vm._s(_vm.value))]):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }